/**
 * @fileoverview added by tsickle
 * Generated from: models/postcode.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/**
 * Base model for a UK postcode, having an "outward" code (e.g. "EC1R")
 * and an "inward" code (e.g. "3BU").
 * @record
 */
function BasePostcodeModel() { }
if (false) {
    /**
     * The inward code, which is the second part of the postcode.
     * @type {?}
     */
    BasePostcodeModel.prototype.inward;
    /**
     * Latitude and longitude of postcode
     * @type {?}
     */
    BasePostcodeModel.prototype.location;
    /**
     * The outward code, which is the first part of the postcode.
     * @type {?}
     */
    BasePostcodeModel.prototype.outward;
    /**
     * If the postcode is within the congestion zone.
     * @type {?}
     */
    BasePostcodeModel.prototype.isWithinCongestionCharge;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
function PostcodeExpandables() { }
if (false) {
    /** @type {?|undefined} */
    PostcodeExpandables.prototype.area;
}
/**
 * Helper properties for the `Postcode` model.
 * @record
 */
function PostcodeModelMixin() { }
if (false) {
    /** @type {?} */
    PostcodeModelMixin.prototype.display;
    /** @type {?} */
    PostcodeModelMixin.prototype.full;
}
/**
 * Model representing a UK postcode.
 * @record
 */
export function Postcode() { }
/** @type {?} */
export var postcode = model.extend((/** @type {?} */ ({
    modelName: 'postcode'
})));
defineModelProperties(postcode, {
    display: {
        get: /**
         * @return {?}
         */
        function () {
            return this.outward + "\u00A0" + this.inward;
        }
    },
    full: {
        get: /**
         * @return {?}
         */
        function () {
            return this.outward + " " + this.inward;
        }
    }
});
